import { Close, Done, KeyboardArrowDown, KeyboardArrowUp, Launch } from "@material-ui/icons"
import { Chip } from "@mui/material"
import Box from "@mui/material/Box"
import Collapse from "@mui/material/Collapse"
import IconButton from "@mui/material/IconButton"
import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Typography from "@mui/material/Typography"
import { useState } from "react"
import { Link } from "react-router-dom"
import { deriveProcessorUri, gameStatusToMuiColor, processorTypeToLabel } from "../utils"

export default function ProcessorsTable({ processors }) {
	if (!(processors && processors.length > 0)) return <div>No processors found</div>

	processors.sort((a, b) => a.id - b.id)
	return (
		<TableContainer component={Paper}>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell width={"0.5rem"} />
						<TableCell>ID</TableCell>
						<TableCell>Processor</TableCell>
						<TableCell align="center">Current Status</TableCell>
						<TableCell align="right">Last Updated</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{processors.map(processor => (
						<ProcessorRow key={processor.id} processor={processor} />
					))}
				</TableBody>
			</Table>
		</TableContainer>
	)
}

function ProcessorRow(props) {
	const { processor } = props
	const [open, setOpen] = useState(false)
	const statusColor = gameStatusToMuiColor(processor?.status)
	const processorName = processorTypeToLabel(processor.type, processor?.team?.abbreviation)
	const uri = deriveProcessorUri(processor.resourceId, processor.type)

	return (
		<>
			<TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
				<TableCell>
					<IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
						{open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
					</IconButton>
				</TableCell>
				<TableCell component="th" scope="row">
					{processor.id}
				</TableCell>
				<TableCell>
					<a href={uri} target="_blank" rel="noreferrer">
						{processorName}
						{uri && <Launch fontSize="small" style={{ verticalAlign: "middle", marginLeft: "0.125rem" }} />}
					</a>
				</TableCell>
				<TableCell align="center">
					<Chip label={processor.status} color={`${statusColor}`} />
				</TableCell>
				<TableCell align="right">{processor.modifiedDateTime}</TableCell>
			</TableRow>
			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box sx={{ margin: 1 }}>
							<Typography variant="h6" gutterBottom component="div">
								Log History for Processor #{processor.id} ({processorName})
							</Typography>
							<Table size="small">
								<TableHead>
									<TableRow>
										<TableCell>ID</TableCell>
										<TableCell align="center">Status</TableCell>
										<TableCell>Game Event Pipeline</TableCell>
										<TableCell align="center">Successful?</TableCell>
										<TableCell>Request ID</TableCell>
										<TableCell align="right">Timestamp</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{processor.logs?.map(log => (
										<LogRow key={log.id} log={log} />
									))}
								</TableBody>
							</Table>
						</Box>
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	)
}

function LogRow(props) {
	const { log } = props
	const statusColor = gameStatusToMuiColor(log?.status)

	return (
		<TableRow key={log.id}>
			<TableCell component="th" scope="row">
				{log.id}
			</TableCell>
			<TableCell align="center">
				<Chip label={log.status} color={statusColor} />
			</TableCell>
			<TableCell>
				{log.gameEventPipeline?.id ? (
					<Link
						to={`/asset-detail/${log.gameEventPipeline.gamePk}?feedType=${log.gameEventPipeline.feedType.code}&gamePipelineId=${log.gameEventPipeline.id}`}
					>
						{log.gameEventPipeline.id}
					</Link>
				) : (
					"N/A"
				)}
			</TableCell>
			<TableCell align="center">
				{log.failed ? (
					<Close fontSize="small" style={{ verticalAlign: "middle" }} />
				) : (
					<Done fontSize="small" style={{ verticalAlign: "middle" }} />
				)}
			</TableCell>
			<TableCell>{log.requestId}</TableCell>
			<TableCell align="right">{log.createdDateTime}</TableCell>
		</TableRow>
	)
}
